import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus } from './machine-schemas';

@inject(DataService, Api, Router)
export class MachineConfirm {
	/** Component methods **/
	constructor(ds, api, router){
		this.ds		= ds;
		this.api	= api;
		this.router = router;
	}

	activate(params){ this.id = params.id }

	attached(){
		// Load user datasets
		window.setTimeout( () => { this.init(); }, 300);
	}

	init(){

		let machine = this.ds.app_data.machine;
		
		if(machine){
			this.machine = machine;
			this.dataset = this.ds.app_data.dataset;
		}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
			})
		}

	}

	/** API Calls **/
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}

	updateMachine(machine, fields){
		let request = new Request("/api/v2/machines/", "PUT");
		let body		= { machine: machine, fields:fields };
		request.body	= JSON.stringify(body);
		return this.api.put(request);
	}

	handleResponseMachineUpdate(response){
		// console.log("update response => ", response);
	}
	
	/** Transition methods **/
	done(){
		let id 		= this.id;
		let machine = this.machine;
		// Update local machien status to < Train >
		this.ds.app_data.machine.status = MachineStatus.Ready;
		// Update remote machine
		let fields = 	{ "status": MachineStatus.Ready };
		this.updateMachine(machine, fields).then(response => {
			this.handleMachineResponse(response);
		})
		.finally( () => {
			// Navigate to Model dashboard
			this.router.navigateToRoute("models.data", {id: id});
		});
	}

	/** Aux functios */
	formatBytes(bytes, decimals = 2) {
		if (!+bytes) return '0 Bytes'
		const k = 1024
		const dm = decimals < 0 ? 0 : decimals
		const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		const i = Math.floor(Math.log(bytes) / Math.log(k))
		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
	}
}
